import { render, staticRenderFns } from "./CopyrightAssignmentTransferFormFilesDetails.vue?vue&type=template&id=6ab469a4&scoped=true&"
import script from "./CopyrightAssignmentTransferFormFilesDetails.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferFormFilesDetails.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferFormFilesDetails.vue?vue&type=style&index=0&id=6ab469a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab469a4",
  null
  
)

export default component.exports